export default "__VITE_ASSET__zSMnrQdY__"